import { Checkbox, Icon } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onCheck } from './../../../../../actions/ordersAction';
import { orderStatus, shipmentStatus } from './../../../../../constants';
import lang from './../../../../../languages/en';
import iconAmazon from './../../../../../resources/imgs/amazon.png';
import { convertDateFromUTC } from './../../../../../services/dst';
import history from './../../../../../services/history';
import { alertError } from './../../../../../services/dialog';
import { getImageChannel } from './../../../../../constants/order';

const OrderCannotEdit = [orderStatus.SENT_TO_SHIPMENT, shipmentStatus.TRANSMITED_KTE, shipmentStatus.IMPORTED_KTE]

class Row extends Component {
    renderStatusOrder = (statusID) => {
        switch (statusID) {
            case orderStatus.AWAITING_FINALIZATION:
                return 'Awaiting Finalization'
            case orderStatus.AWAITING_SHIPMENT:
                return 'Awaiting Shipment'
            case shipmentStatus.TRANSMITED_KTE:
            case shipmentStatus.IMPORTED_KTE:
            case orderStatus.SENT_TO_SHIPMENT:
                return 'Sent To Shipment'
            case orderStatus.SPLIT:
                return 'Split'
            default:
                return ''
        }
    }

    editOrder = (e, i) => {
        if (e.type === 'mousedown') {
            this.x = e.pageX;
            this.y = e.pageY;
        }

        if (e.type === 'mouseup' && this.x === e.pageX && this.y === e.pageY && e.button !== 2) {
            if (!OrderCannotEdit.includes(this.props.orders[i].StatusID)) {
                history.push('/orders/edit?order_id=' + this.props.orders[i].ID)
            } else { this.messageCannotEdit() }
        }
    }

    messageCannotEdit = () => {
        alertError(lang.can_not_edit_order)
    }

    render() {
        const { i, obj } = this.props

        return (
            <tr key={i}>
                <td width="2%" className={"checkTd " + (this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? "orders-error" : "")}>
                    <Checkbox
                        checked={this.props.listIdCheckedOrders.includes(this.props.orders[i].ID) ? true : false}
                        onChange={() => this.props.onCheck(obj)}
                    />
                </td>
                <td width="12%"
                    className={(this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? "orders-error" : "")}
                    onMouseUp={(e) => this.editOrder(e, i)}
                    onMouseDown={(e) => this.editOrder(e, i)}
                >
                    {getImageChannel(this.props.orders[i]['ChannelName'])}
                </td>
                <td width="21%"
                    className={(this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? "orders-error" : "")}
                    onMouseUp={(e) => this.editOrder(e, i)}
                    onMouseDown={(e) => this.editOrder(e, i)}
                >
                    {this.props.orders[i].ChannelOrderID}
                </td>
                <td width="15%"
                    className={(this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? "orders-error" : "")}
                    onMouseUp={(e) => this.editOrder(e, i)}
                    onMouseDown={(e) => this.editOrder(e, i)}
                >
                    {convertDateFromUTC(this.props.orders[i].OrderDT).format('MM/DD/YYYY')}
                </td>
                <td width="15%"
                    className={(this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? "orders-error" : "")}
                    onMouseUp={(e) => this.editOrder(e, i)}
                    onMouseDown={(e) => this.editOrder(e, i)}
                >
                    {this.props.orders[i].DestinationCountryCH}
                </td>
                <td width="20%"
                    className={(this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? "orders-error customer-name" : "customer-name")}
                    onMouseUp={(e) => this.editOrder(e, i)}
                    onMouseDown={(e) => this.editOrder(e, i)}
                >
                    {this.props.orders[i].ConsigneeNameCH}</td>
                <td width="15%"
                    className={(this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? "orders-error status-error" : "")}
                    onMouseUp={(e) => this.editOrder(e, i)}
                    onMouseDown={(e) => this.editOrder(e, i)}
                >
                    {(this.props.orders[i].StatusID === orderStatus.AWAITING_FINALIZATION ? <div className="div-warning-icon"><Icon type="exclamation" theme="outlined" /></div> : null)}
                    {this.renderStatusOrder(this.props.orders[i].StatusID)}
                </td>
            </tr>
        );
    }
}

const mapStateToProps = state => {
    return {
        orders: state.ordersReducer.orders,
        listIdCheckedOrders: state.ordersReducer.listIdCheckedOrders,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onCheck: payload => {
            dispatch(onCheck(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Row)



// WEBPACK FOOTER //
// ./src/containers/orders/list/components/row/index.js